// Remerciements de la fenêtre « À propos » (ui/aboutDialog.js) : les logiciels et ressources libres distribués avec le jeu, avec leur
// auteur et leur licence, puis les sources des textes. À mettre à jour à chaque dépendance ou ressource tierce ajoutée (les mentions
// complètes sont dans public/fonts/NOTICE.md et public/emoji/NOTICE.md ; les outils de développement ne sont pas distribués).
//   libraries : { name, author, license }
//   sources   : { name, license, note: { fr, en } } (texte simple : pas de lien)
export const LIBRARIES = Object.freeze([
  { name: 'Tone.js', author: 'Yotam Mann', license: 'MIT' },
  { name: 'qrcode-generator', author: 'Kazuhiko Arase', license: 'MIT' },
  { name: 'Workbox', author: 'Google', license: 'MIT' },
  { name: 'Tailwind CSS', author: 'Tailwind Labs', license: 'MIT' },
  { name: 'Capacitor', author: 'Ionic', license: 'MIT' },
  { name: 'Apache Cordova', author: 'Apache Software Foundation', license: 'Apache 2.0' },
  { name: 'AndroidX', author: 'Google', license: 'Apache 2.0' },
  { name: 'Fredoka', author: 'Milena Brandão', license: 'SIL OFL 1.1' },
  { name: 'IBM Plex Mono', author: 'IBM', license: 'SIL OFL 1.1' },
  { name: 'Noto Emoji', author: 'Google', license: 'Apache 2.0' },
]);

export const SOURCES = Object.freeze([
  {
    name: 'Wikipédia',
    license: 'CC BY-SA 4.0',
    note: {
      fr: 'Divinités de la mythologie japonaise dont s’inspirent les noms et les caractères des kami',
      en: 'Deities of Japanese mythology that inspire the kamis’ names and characters',
    },
  },
]);

/** Mention d'une bibliothèque ou d'une ressource : « Nom (auteur, licence) ». */
export function libraryLine({ name, author, license }) {
  return `${name} (${author}, ${license})`;
}
